import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gaming-platform',
  templateUrl: './gaming-platform.component.html',
  styleUrls: ['./gaming-platform.component.css']
})
export class GamingPlatformComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gaming-platform/gaming-platform.component.ts